import getWritableCalendarsForUser from './getWritableCalendarsForUser';
import getSelectedCalendarsForUser from './getSelectedCalendarsForUser';
import { Calendar, isGroupCalendar } from 'owa-calendar-cache';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Returns the list of calendars for the calendar picker in the forms.
 * These are writeable calendars. In the case of group calendars, they must also be selected.
 */
export default function getCalendarsForCalendarPicker(
    event: CalendarEvent,
    userIdentity: string
): Calendar[] {
    const calendars = getWritableCalendarsForUser(event, userIdentity);
    const selectedCalendars = getSelectedCalendarsForUser(userIdentity);
    const nonGroupOrSelectedGroupCalendars = calendars.filter(
        calendar =>
            !isGroupCalendar(calendar) ||
            selectedCalendars.map(cal => cal.id.id).indexOf(calendar.id.id) !== -1
    );
    return nonGroupOrSelectedGroupCalendars;
}
